import React from "react";
import GiveForm from "./GiveForm";

const GiveLanding = () => {
  return (
    <div className="flex justify-between flex-col md:flex-row items-center mt-16">
      <div className="self-center w-full md:w-1/2">
        <h1 className="text-dark-blue text-6xl md:text-6xl font-extrabold">
          Have You Been Blessed By Our Podcast?
        </h1>
        <p className="mt-8 md:w-10/12 text-justify font-medium">
          Our goal at The 360 Believer is to equip you with right words, provide
          clarity to difficult Bible subjects, share inspiring stories and
          practical lessons that will 10x the quality of your life.
          <br />
          <br />
          We want to do more. We are very passionate about excellence and this
          will require your generous support.
        </p>
      </div>
      <div className="md:w-2/5 w-full mt-12 md:mt-0">
        <GiveForm />
      </div>
    </div>
  );
};

export default GiveLanding;
